import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "../lib/api";
import { FactCheckResult } from "../components/FactCheckResult";
import { Button } from "../components/ui/button";
import { ArrowLeft } from "lucide-react";

export default function CheckDetail() {
    const { id } = useParams();
    const [result, setResult] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        api.get(`/factcheck/${id}`)
            .then((r) => setResult(r.data))
            .catch(() => setError("Fact-check not found"))
            .finally(() => setLoading(false));
    }, [id]);

    return (
        <div className="max-w-4xl mx-auto px-6 lg:px-10 py-14">
            <Link to="/trending" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-accent mb-8" data-testid="back-to-trending">
                <ArrowLeft className="h-4 w-4" /> Back
            </Link>
            {loading && <p className="text-muted-foreground text-sm">Loading…</p>}
            {error && (
                <div className="card-surface p-10 rounded-2xl text-center">
                    <p className="text-muted-foreground">{error}</p>
                    <Link to="/"><Button className="mt-4 rounded-full bg-primary text-primary-foreground">Home</Button></Link>
                </div>
            )}
            {result && <FactCheckResult result={result} />}
        </div>
    );
}
